import { Figure } from '~/src/figure';
import { IId } from '~/src/figure/Item';
import { Piece } from '~/src/figure/Piece';
import { Ruler } from '~/src/figure/Ruler';

export const getRuler = ( rid : IId ) => ( fig : Figure ): undefined | Ruler =>
	fig.Pieces.flatMap( ( pce : Piece ) =>
		pce.Rulers.filter( ( rlr : Ruler ) => rlr.Id === rid )
	)[0];


